import { styled } from '@mui/material/styles';
import { TableRow as MuiTableRow } from '@mui/material';

const SplitterTableRow = styled(MuiTableRow)(({ theme }) => ({
    '& td': {
        padding: theme.spacing(0),
    }
}));

export { SplitterTableRow };
